/* global domain */
/* global FullCalendar */
/* global Instafeed */
/* global TimelineMax */


window.odometerOptions = {
  format: 'dd', // Change how digit groups are formatted, and how many digits are shown after the decimal point
};

function convertDateSqlToDate(dateString){
  var dateParts = dateString.split("-");
  
  // Conversion des parties de la date en nombres
  var year = parseInt(dateParts[0]);
  var month = parseInt(dateParts[1]) - 1; // Les mois dans JavaScript sont basés sur zéro (0 = janvier)
  var day = parseInt(dateParts[2]);
  
  // Création de l'objet Date
  return new Date(year, month, day);
}

$(document).ready(function(){  

  tarteaucitron.init({
    "privacyUrl": "https://www.efp.be/politique-de-protection-des-donnees/", /* Url de la politique de confidentialité */
    "bodyPosition": "top", /* top place le bandeau de consentement au début du code html, mieux pour l'accessibilité */
    "hashtag": "#cookies", /* Hashtag qui permet d'ouvrir le panneau de contrôle  */
    "cookieName": "efpcookies", /* Nom du cookie (uniquement lettres et chiffres) */
    "orientation": "middle", /* Position de la bannière (top - bottom - popup - banner) */
    "groupServices": true, /* Grouper les services par catégorie */
    "showDetailsOnClick": true, /* Cliquer pour ouvrir la description */
    "serviceDefaultState": "wait", /* Statut par défaut (true - wait - false) */
    "showAlertSmall": false, /* Afficher la petite bannière en bas à droite */
    "cookieslist": false, /* Afficher la liste des cookies */
    "closePopup": true, /* Afficher un X pour fermer la bannière */
    "showIcon": true, /* Afficher un cookie pour ouvrir le panneau */
    //"iconSrc": "", /* Optionnel: URL ou image en base64 */
    "iconPosition": "BottomLeft", /* Position de l'icons: (BottomRight - BottomLeft - TopRight - TopLeft) */
    "adblocker": false, /* Afficher un message si un Adblocker est détecté */                 
    "DenyAllCta" : true, /* Afficher le bouton Tout refuser */
    "AcceptAllCta" : true, /* Afficher le bouton Tout accepter */
    "highPrivacy": true, /* Attendre le consentement */
    "alwaysNeedConsent": false, /* Demander le consentement même pour les services "Privacy by design" */
    "handleBrowserDNTRequest": false, /* Refuser tout par défaut si Do Not Track est activé sur le navigateur */
    "removeCredit": true, /* Retirer le lien de crédit vers tarteaucitron.io */
    "moreInfoLink": false, /* Afficher le lien En savoir plus */
    "useExternalCss": false, /* Mode expert : désactiver le chargement des fichiers .css tarteaucitron */
    "useExternalJs": false, /* Mode expert : désactiver le chargement des fichiers .js tarteaucitron */
    //"cookieDomain": ".my-multisite-domaine.fr", /* Optionnel: domaine principal pour partager le consentement avec des sous domaines */
    "readmoreLink": "", /* Changer le lien En savoir plus par défaut */
    "mandatory": true, /* Afficher un message pour l'utilisation de cookies obligatoires */
    "mandatoryCta": false, /* Afficher un bouton pour les cookies obligatoires (déconseillé) */
    //"customCloserId": "", /* Optionnel a11y: ID personnalisé pour ouvrir le panel */
    "googleConsentMode": true, /* Activer le Google Consent Mode v2 pour Google ads & GA4 */
    "bingConsentMode": true, /* Activer le Bing Consent Mode pour Clarity & Bing Ads */
    "softConsentMode": false, /* Soft consent mode (le consentement est requis pour charger les tags) */
    "dataLayer": false, /* Envoyer un événement dans dataLayer avec le statut des services */
    "serverSide": false, /* Server side seulement, les tags ne sont pas chargé côté client */
    "partnersList": false /* Afficher le détail du nombre de partenaires sur la bandeau */
  });

  tarteaucitron.user.googletagmanagerId = 'GTM-M89567S';
  (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');

  tarteaucitron.user.facebookpixelId = '1035847111243299'; tarteaucitron.user.facebookpixelMore = function () { /* add here your optionnal facebook pixel function */ };
  (tarteaucitron.job = tarteaucitron.job || []).push('facebookpixel');

  var popup = sessionStorage.getItem("viewedPopup");
  
  if ( popup == 'true') {
    
    $('.popup-news').hide();
  } else {
    $('.popup-news').fadeIn();
    sessionStorage.setItem("viewedPopup", true);
  }

  if ( $('.collapse-panel').length ){
    const panels = document.querySelectorAll('.collapse-panel');

    panels.forEach((panel, index) => {
      // Sélectionner l'élément du titre et le contenu du panneau
      const heading = panel.querySelector('h6 a');
      const content = panel.querySelector('.panel-content');

      // Créer des identifiants uniques pour les éléments
      const headingId = `accordion-heading-${index}`;
      const contentId = `accordion-content-${index}`;

      // Ajouter des attributs ARIA aux éléments de l'accordéon
      heading.setAttribute('role', 'button');
      heading.setAttribute('aria-expanded', 'false');
      heading.setAttribute('aria-controls', contentId);
      heading.id = headingId;
      heading.setAttribute('tabindex', '0'); // Permettre le focus sur l'élément avec Tab

      // Ajouter les attributs ARIA au contenu de l'accordéon
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', headingId);
      content.setAttribute('aria-hidden', 'true');
      content.id = contentId;

      // Ajouter un écouteur d'événement pour gérer le clic sur le titre
      heading.addEventListener('click', () => togglePanel(heading, content));

      // Ajouter un écouteur pour les touches du clavier
      heading.addEventListener('keydown', (event) => {
        switch (event.key) {
          case ' ':
          case 'Enter':
              // Ouvrir ou fermer le panneau avec Espace ou Entrée
              event.preventDefault();
              togglePanel(heading, content);
              break;
          case 'ArrowDown':
              // Naviguer vers le panneau suivant
              event.preventDefault();
              focusNextPanel(index);
              break;
          case 'ArrowUp':
              // Naviguer vers le panneau précédent
              event.preventDefault();
              focusPreviousPanel(index);
              break;
          default:
              break;
        }
      });
    });

    // Fonction pour ouvrir ou fermer un panneau
    function togglePanel(heading, content) {
        const isExpanded = heading.getAttribute('aria-expanded') === 'true';
        heading.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
        $(heading).closest('.collapse-panel').find('.panel-content').slideToggle();
    }

    // Fonction pour naviguer vers le panneau suivant
    function focusNextPanel(currentIndex) {
        const nextIndex = (currentIndex + 1) % panels.length;
        panels[nextIndex].querySelector('h6 a').focus();
    }

    // Fonction pour naviguer vers le panneau précédent
    function focusPreviousPanel(currentIndex) {
        const previousIndex = (currentIndex - 1 + panels.length) % panels.length;
        panels[previousIndex].querySelector('h6 a').focus();
    }
  }

  $('.tooltip-target').on('mouseenter', function(){
    $('.tooltip-recrute').fadeIn('fast');
  }).on('mouseleave', function(){
    $('.tooltip-recrute').fadeOut('fast');
  });

  if ($('#offre_datepicker').length){
    var date_min = $('#offre_datepicker').data('min');
    var date_max = $('#offre_datepicker').data('max');

    $('#offre_datepicker').datepicker({
      dateFormat: "d/m/yy",
      minDate: convertDateSqlToDate(date_min), // Date minimale (1er janvier 2023)
      maxDate: convertDateSqlToDate(date_max), // Date maximale (31 décembre 2023)
      onSelect: function(dateText) {
        // Vérifier si le format est valide
        var pattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
        if (!pattern.test(dateText)) {
          alert("Format de date invalide. Veuillez utiliser le format jour/mois/année (d/m/Y).");
          $(this).val(""); // Réinitialiser la valeur du champ
        }
      }
    });
  }

  $('.js-accordeon-btn').on('click', function(e){
    e.preventDefault();
    $('.accordeon-item').removeClass('-open');
    $(this).closest('.accordeon-item').addClass('-open')
  });

  $('.js-scroll-btn').on('click', function(e){
    e.preventDefault();
    var block = $(this).attr('href');
    $('body, html').animate({
          scrollTop: $(block).offset().top - 70
      }, 1000);
  });

  var placeholderText = [
      "Boucher",
      "Boulanger", 
      "Développeur", 
      "Agent"
    ];

  $('#search').placeholderTypewriter({text: placeholderText});

  if ( $('.headline-23-slider').length ) {
    var $homeSlider = $('.headline-23-slider');

    $homeSlider.on('init.slick', function(event, slick){
      $('.shadow-headline-text').addClass('-visible');
    });

    $homeSlider.slick({
      fade: true,
      autoplay: true,
      slidesToShow: 1,
      infinite: true,
      autoplaySpeed: 5000,
      speed: 950,
      dots: false,
      draggable: true,
      arrows: false
    });
  }
  
  if ( $('.slider').length ) {
    $('.slider').slick({
      fade: true,
      autoplay: false,
      slidesToShow: 1,
      infinite: false,
      dots: true,
      accessibility: false,
      arrows: false
    });
  }

  if ( $('.actualites-slider').length ) {
    $('.actualites-slider').slick({
      fade: true,
      autoplay: false,
      slidesToShow: 1,
      infinite: false,
      dots: true,
      accessibility: false,
      arrows: false
    });
  }

  if ( $('.temoignages-block').length ) {
    $('.temoignages-slider').slick({
      fade: false,
      autoplay: true,
      autoplaySpeed: 15000,
      dots: false,
      accessibility: false,
      arrows: true,
      speed: 700,
    });
  }
  
  $('.project-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    fade: true,
    cssEase: 'linear'
  });

  $('.partenaires-slider').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: true,
    autoplay: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  });

  var arrowSlider = false;
  if ( $(window).width() <= 780 ) {
    arrowSlider = true;
  }

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: arrowSlider,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
    focusOnSelect: true
  });

  /*var allEvents = [];

  $('.js-efp-events').find('.js-event-item').each(function(i){

      allEvents.push({
          id : '_0' + i,
          title : $(this).data('name') || '',
          description : $(this).find('.js-event-intro').text() || '',
          start : $(this).data('date') || '',
          end : $(this).data('end') || '',
          allDay: true,
          url : $(this).data('link') || '', 
          color: '#197ca0',
          backgroundColor: '#197ca0'
      });

  });*/

  if ( $('#calendar').length ) {
    var calendarEl = document.getElementById('calendar');

    var calendar = new FullCalendar.Calendar(calendarEl, {
      initialView: 'dayGridMonth',
      timeZone: 'UTC',
      locale: 'fr',
      firstDay: 1,
      events: domain + '/efp/ajax/calendarEvents.php',
      color: '#197ca0',   // an option!
      textColor: '#197ca0',
      buttonText: {
        today:'Aujourd\'hui'
      },
    });
    calendar.render();
  }
  
  if ( $('.default-editor').length ) {
    tinymce.init({
      selector: 'textarea.default-editor',
      promotion: false,
      statusbar: false,
      menubar: false,
      plugins: 'lists',
      toolbar: 'bold italic backcolor | alignleft aligncenter ' +
      'alignright alignjustify | bullist numlist outdent indent | '
    });
  }

  $('.js-agenda-vue-btn').on('click', function(e){
    e.preventDefault();
    var vueType = $(this).data('vue');
    $('.js-agenda-vue-btn').show();
    $(this).hide();
    $('.js-vue-agenda, .js-vue-listing').hide();
    $('.js-vue-' + vueType).fadeIn();

    if ( vueType === 'both') {
      $('.js-vue-agenda, .js-vue-listing').fadeIn();
    }
  });

  $('#efp-menu').slicknav({
    label: '',
    init: function(trigger){
      $('.slicknav_nav').append('<a href="https://www.efp.be/inscriptions/" class="link -navigation px2"><span class="name">Inscription</span></a>')
      $('.slicknav_nav').append('<a href="https://www.efp.be/mon-efp/espace-personnel/" class="link -navigation px2"><span class="name">Mon efp</span></a>')
    }
  });

  // let $gridPartner = $('.partner-grid').isotope({
  //   itemSelector: '.partenaire-item'
  // });

  // $('.js-filter-btn').on('click', function(e){
  //   e.preventDefault();
  //   var category = $(this).data('filter');
    
  //   $gridPartner.isotope({
  //     filter: category
  //   });
  // });

  $('.js-partenaires, .js-association').hide();

  $('.js-filter-btn').on('click', function(e){
      e.preventDefault();
      var category = $(this).data('filter');

      if ( category == '.association' ) {
        $('.js-partenaires, .js-all-partenaires').hide();
        $('.js-association').fadeIn();
      } else if ( category == '.non_membre' ) {
        $('.js-association, .js-all-partenaires').hide();
        $('.js-partenaires').fadeIn();
      } else {
        $('.js-partenaires, .js-association').hide();
        $('.js-all-partenaires').fadeIn();
      }
      

  })

  if ( $('.hot-actu').length ) {
    $('.logo-wrapper').addClass('-actu');
  }

  // $('.collapse-panel h6 a').on('click', function(e){
  //   e.preventDefault();
  //   $(this).closest('.collapse-panel').find('.panel-content').slideToggle();
  // });

  $('.js-newsletter-btn').on('click', function(e){
    e.preventDefault();
    $('.form-wrapper').fadeIn();
    setTimeout(function(){
      $('.form-wrapper').find('#gcaptcha').css({
        '-webkit-transform' : 'scale(1)',
        '-moz-transform'    : 'scale(1)',
        '-ms-transform'     : 'scale(1)',
        '-o-transform'      : 'scale(1)',
        'transform'         : 'scale(1)',
        'display'           : 'block'
      });
    }, 400);
  });

  let windWidth = $(window).width();
  if ( windWidth <= 815 ) {
    let $htmlLastItem = $('.js-last-item');
    $('.js-content-container').append($htmlLastItem);
  }

  if ( $('.js-random-image').length ) {
    let image = Math.floor((Math.random() * 7) + 1);
    $('.js-random-image').css("background-image", "url(./../files/Image/random-images/0"+ image +".jpg)");  
  }

  // Scroll on home CTA click
  if ( $('.js-formation-block').length ) {
    let formationsOffset = $('.js-formation-block').offset().top
    $('.js-cta-home').on('click', function(e){
      e.preventDefault();
      $('body, html').animate({
          scrollTop: formationsOffset - 70
      }, 1000);
    });
  }

  $('.js-change-slide-btn').on('click', function(e){
    e.preventDefault();
    let slideToShow = $(this).data('slide');
    $('.js-change-slide-btn').removeClass('-active');
    $(this).addClass('-active');
    $('.case-thumb, .case-content').addClass('-hidden');
    $('[data-image="'+ slideToShow +'"]').removeClass('-hidden');
    $('[data-content="'+ slideToShow +'"]').removeClass('-hidden');
  });

  $('.js-select-formation').select2({
    placeholder: 'Cherchez une formation ici',
    allowClear: false,
    "language": {
       "noResults": function(){
           return "Aucune correspondance trouvée";
       }
   },
    escapeMarkup: function (markup) {
        return markup;
    }
  });

  selectStageDelegue();

  function getId(url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
        return match[2];
    } else {
        return 'error';
    }
  }

  var videoModal = $('[data-remodal-id=modal-videos]').remodal();
  $('.js-video-link').on('click', function(e){
    e.preventDefault();
    var video = $(this).data('link');
    var videoId = getId(video);

    var iframeMarkup = '<iframe width="100%" height="400" src="//www.youtube.com/embed/' + videoId + '?controls=0" frameborder="0" allowfullscreen></iframe>';
    $('[data-remodal-id=modal-videos]').find('.js-video-block').empty().append(iframeMarkup);
    videoModal.open();
  });

  $(".js-select-formation").on('change', function() {
    let selectedFormation = $(this).val();
    $(location).attr('href' , selectedFormation);
  });

  setTimeout(function(){
    $('.js-fadein-image').css('opacity', 1);
  }, 300);


  $('.close-popup').on('click', function(e){
    e.preventDefault();
    sessionStorage.setItem("viewedPopup", true);
    $('.popup-news').fadeOut();
  });


  // Fixed menu on Home page
  const winHeight = $( window ).height();
  if ( $('.js-metrics-block').length ) {
    const metricsBlock = $('.js-metrics-block').offset().top - window.innerHeight;
    let odometer1 = $('#odometer-1').data('val');
    let odometer2 = $('#odometer-2').data('val');
    let odometer3 = $('#odometer-3').data('val');
    let odometer4 = $('#odometer-4').data('val');
    
    $(window).scroll(function () {
      let scroll = $(window).scrollTop();
      var fixedPadding, fixedPadding2;

      if ( $('.hot-actu').length ) {
        $('.logo-wrapper').addClass('')
        fixedPadding = 0
        fixedPadding2 = 70
      } else {
        fixedPadding = 0
        fixedPadding2 = 63
      }

      if ( scroll > parseInt(winHeight) + fixedPadding ) {
        $('body').addClass('menu-fixed');
      } else {
        $('body').removeClass('menu-fixed');
      }

      // if ( scroll > parseInt(winHeight) + fixedPadding2 ) {
      //   $('body').addClass('menu-block-fixed');
      //   $('.js-menu-block').addClass('-fixed');
      // } else {
      //   $('body').removeClass('menu-block-fixed');
      //   $('.js-menu-block').removeClass('-fixed');
      // }

      if (scroll > metricsBlock+350) {
        $('#odometer-1').html(odometer1);
        $('#odometer-2').html(odometer2);
        $('#odometer-3').html(odometer3);
        $('#odometer-4').html(odometer4);
      }
    });
  } else {
    $(window).scroll(function () {
      let scroll = $(window).scrollTop();

      if ( $('.hot-actu').length ) {
        $('.logo-wrapper').addClass('')
        var fixedPadding = 70
        var fixedPadding2 = 120
      } else {
        var fixedPadding = 33
        var fixedPadding2 = 60
      }

      if ( scroll > fixedPadding ) {
        $('body').addClass('menu-fixed');
      } else {
        $('body').removeClass('menu-fixed');
      }

      if ( scroll > fixedPadding2 ) {
        $('.js-menu-block').addClass('-fixed');
        $('body').addClass('-pages');
      } else {
        $('.js-menu-block').removeClass('-fixed');
        $('body').removeClass('-pages');
      }
    });
  }

  if (  $('.accordeon-wrapper').length ) {

    let $grid = $('.js-accordeon-content').each(function(){
      $(this).isotope({
        itemSelector: '.element-item',
        layoutMode: 'vertical',
        queue: false
      });
    });

    var iso = $grid.data('isotope');

    $('.js-section-title').each(function(){
      $(this).closest('.accordeon-item').find('.js-fiche-item').each(function(index){
        $(this).closest('.accordeon-item').find('.js-fiche-counter').text(index+1);
      });
    });

    // $('.js-section-title').on('click', function(e){
    //   e.preventDefault();
    //   $(this).closest('.accordeon-item').find('.js-accordeon-content').slideToggle();
    //   // $(this).find('.js-tab-icon').toggleClass('fa-chevron-down ').toggleClass('fa-times');
    //   $(this).find('.js-tab-icon').toggleClass('opened');
    // });
    
    // Filtre par catégorie
    $('.js-category-btn').on('click', function(e){
      e.preventDefault();
      $('.js-category-btn').find('.checkbox').removeClass('-checked');
      $(this).find('.checkbox').addClass('-checked');
      
      let category = $(this).data("filter");

      window.location.hash = category;

      $grid.isotope({
        filter: category
      });

      $('.js-section-title').each(function(){
        var accordeon = $(this).parents('.accordeon-item');
        var items = accordeon.find('.js-fiche-item');
        
        var nbrFiche = 0;
        items.each(function(){
          if ( $(this).hasClass(category.substring(1) ) ) {
            nbrFiche++;
          } 
        });
        
        accordeon.find('.js-fiche-counter').text(nbrFiche);
      });
    });
    
    // Display category via le hash de l'url . Ex : https://www.efp.be/passeport-reussite#.cat_07
    let hashUrl = window.location.hash.substring(1);
    if (hashUrl != ''){
      let btn = $('.js-category-btn[data-filter=\''+hashUrl+'\']');
      if (btn.length){
        btn.click();
      }
    }

    $grid.isotope( 'on', 'layoutComplete', function() {
      $.each( iso.filteredItems, function( i, item ) {
        $( item.element ).removeClass('-light');
        var method = i % 2 ? 'removeClass' : 'addClass';
        $( item.element )[ method ]('-light');
      });
    });
  }

  if ( $('.grid').length ) {
    let $grid = $('.grid').isotope({
      itemSelector: '.element-item',
      layoutMode: 'vertical'
    });

    let categoryHash = decodeURIComponent(window.location.hash.substring(1));
    let formationBlock = $('.js-formation-block');

    // Liste des valeurs à ignorer
    const ignoredHashes = ['formationblock', 'nocat', ''];

    if (ignoredHashes.includes(categoryHash)) {
      // Cas : hash à ignorer → on affiche tout
      $('.js-category-btn').find('.checkbox').removeClass('-checked');

      // Facultatif : activer visuellement le bouton "Toutes les formations"
      $('.js-category-btn[data-filter="*"]').find('.checkbox').addClass('-checked');

      $grid.isotope({ filter: '*' });

    } else {
      // Cas : hash contient des filtres valides
      $('.js-category-btn').find('.checkbox').removeClass('-checked');

      let selectors = categoryHash.split(',').map(sel => sel.trim());

      selectors.forEach(selector => {
        let individualClasses = selector.match(/\.[^\.]+/g); // ex: .cat1.cat2 → [.cat1, .cat2]
        if (individualClasses) {
          individualClasses.forEach(cls => {
            $(`.js-category-btn[data-filter="${cls}"]`).find('.checkbox').addClass('-checked');
          });
        }
      });

      $grid.isotope({ filter: categoryHash });
    }

    // Scroll vers les formations après chargement
    setTimeout(function () {
      let offset = $(window).width() < 500 ? 55 : 200;
      $('html, body').animate({
        scrollTop: formationBlock.offset().top - offset
      }, 500);
    }, 300);

    const exclusiveFilters = [
      '.lieu_bruxelles',
      '.lieu_entreprise_bxl',
      '.lieu_formation_entreprise'
    ];

    $('.js-category-btn').on('click', function(e){
      e.preventDefault();

      let $btn = $(this);
      let $checkbox = $btn.find('.checkbox');
      let filter = $btn.data("filter");
      let isExclusive = exclusiveFilters.includes(filter);
      let isChecked = $checkbox.hasClass('-checked');

      if (isExclusive) {
        exclusiveFilters.forEach(f => {
          $('.js-category-btn[data-filter="' + f + '"]').find('.checkbox').removeClass('-checked');
        });

        if (!isChecked) {
          $checkbox.addClass('-checked');
        }

      } else {
        $checkbox.toggleClass('-checked');
      }

      $('.sub-category').hide();
      $('.js-category-btn .checkbox.-checked').each(function(){
        let selectedFilter = $(this).closest('.js-category-btn').data("filter");
        let subcategory_name = selectedFilter.substring(1);
        if (subcategory_name != '') {
          $('.sub-category.' + subcategory_name).css('display', 'flex');
        }
      });

      // Collecte des filtres actifs
      let activeButtons = $('.js-category-btn .checkbox.-checked').closest('.js-category-btn');
      let andFilters = [];
      let orGroups = {};
      let exclusiveFilter = null;

      activeButtons.each(function(){
        let $this = $(this);
        let filter = $this.data('filter');
        let mode = $this.data('mode');

        if (exclusiveFilters.includes(filter)) {
          exclusiveFilter = filter;
        } else if (mode === 'or') {
          // Regrouper tous les filtres OR
          if (!orGroups['or']) orGroups['or'] = [];
          orGroups['or'].push(filter);
        } else {
          andFilters.push(filter);
        }
      });

      let finalSelector = [];

      // Si filtres OR, créer une variante par filtre OR combiné avec tous les filtres AND
      if (orGroups['or'] && orGroups['or'].length > 0) {
        orGroups['or'].forEach(orFilter => {
          let combo = andFilters.join('') + orFilter;
          if (exclusiveFilter) combo += exclusiveFilter;
          finalSelector.push(combo);
        });
      } else {
        let combo = andFilters.join('');
        if (exclusiveFilter) combo += exclusiveFilter;
        if (combo !== '') {
          finalSelector.push(combo);
        }
      }

      let finalFilter = finalSelector.length > 0 ? finalSelector.join(', ') : '*';

      if (finalFilter === '*') {
        history.pushState("", document.title, window.location.pathname + window.location.search);
      } else {
        window.location.hash = finalFilter;
      }

      $grid.isotope({
        filter: finalFilter
      });
    });

    $grid.on('arrangeComplete', function(event, filteredItems) {
      $('.apprentissage-block').removeClass('-light');
    });

  } else {
    let windowHash = window.location.hash.substring(1);
    let formationBlock = $('.js-formation-block');
    if ( windowHash === 'nocat' ) {
      $('html, body').animate({
        scrollTop: $(formationBlock).offset().top - 250
      }, 700);
    } else if ( windowHash != '' )  {
      $('html, body').animate({
        scrollTop: $("#" + windowHash).offset().top - 250
      }, 700);
    }
  }

  $('[data-remodal-id=modal-videos]').remodal();
    

  $(document).on('keyup', '.easyautocomplete', function(){
    var parent = $(this).parents('.easy-autocomplete');
    var reset = parent.find('.reset-autocomplete');
    if (reset.length == 0){
      parent.append('<a href="#" class="reset-autocomplete"></a>');
    }
  });

  $(document).on('click', '.reset-autocomplete', function(){
    var parent = $(this).parents('.easy-autocomplete');
    parent.find('.easyautocomplete').val('');
    $(this).fadeOut().remove();
    return false;
  });

  $(document).on('click', '.action_offre_valid', function(){
    Swal.fire({
      title: "Etes-vous sûr de vouloir valider l'offre ?",
      text: "L'offre sera disponible en ligne. Un email de confirmation sera envoyé à l'utilisateur",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = $(this).attr('href');
      }
    })
    return false;
  });

  $(document).on('click', '.action_offre_decline', function(){
    Swal.fire({
      title: "Etes-vous sûr de vouloir décliner l'offre ?",
      text: "Un email sera envoyé à l'utilisateur",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = $(this).attr('href');
      }
    })
    return false;
  });
});

$(window).on("load", function() {
  if ($(".easyautocomplete").length){
    var options = {
      url: function() {
        return domain+"/efp/ajax/ajaxFormations.php";
      },
      getValue: function(element) {
          return element.title;
      },
      ajaxSettings: {
        dataType: "json",
        method: "POST",
        data: {
          dataType: "json"
        }
      },
      preparePostData: function(data, text) {
        data.q = text;
        data.category = $('.easyautocomplete').data('category');
        return data;
      },
      requestDelay: 400,
      highlightPhrase: true,
      minCharNumber: 3,
      listLocation: "items",
      list: {
          maxNumberOfElements: 15,
          match: {
            enabled: false
          },
          onSelectItemEvent: function() {
              return false;
          },
          onKeyEnterEvent: function() {
              return false;
          },
          onChooseEvent: function() {
              var autocomplete_active = $('.easy-autocomplete-container ul:visible').parent('.easy-autocomplete-container').prev('input[type="text"]');
              var object = autocomplete_active.getSelectedItemData();
              // var parent = autocomplete_active.parents('.form-group');

              if (object.url != ''){
                window.location.href = object.url;
              }

              return false;
          },
      },	
      adjustWidth: false,
    };

    $(".easyautocomplete").easyAutocomplete(options);
  }
});

function selectStageDelegue(){
  if ($('.js-select-delegueformation').length){

    $('.js-select-delegueformation').select2({
      placeholder: 'Cherchez une formation ici',
      allowClear: true,
      "language": {
        "noResults": function(){
            return "Aucune correspondance trouvée";
        }
    },
      escapeMarkup: function (markup) {
          return markup;
      }
    });

    $(".js-select-delegueformation").on('change', function() {
      let selectedFormation = $(this).val();
      modalStageByFormation(selectedFormation);
    });
  }
  
  if ($('.js-formation-delegue').length){
    $('.js-formation-delegue').on('click',function(){
      let selectedFormation = $(this).data('formation');
      modalStageByFormation(selectedFormation);
      return false;
    });
  }

  if ($('.cat_delegue').length){
    $('.cat_delegue > a.apprentissage-block').on('click',function(){
      var parent = $(this).parents('.cat_delegue');
      var formations = parent.find('.cat_delegue_formations');
      formations.toggle();
      return false;
    });
  }
}

function modalStageByFormation(formationId){
  if (formationId && formationId > 0){
    $('.js-select-delegueformation').val('').trigger('change');
    $.ajax({
      type: "POST",
      url: domain+"/efp/ajax/ajaxStage.php",
      data: { 'formationId' : formationId },
      dataType: "json",
      success: function(data){
        if (data.success){
          $.fancybox.open(data.content);
        }
      },
      failure: function() {
      }
    });
  }
}

// mon efp popup
function Monefp_setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
function Monefp_getCookie(name) {
    const cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].split("=");
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}
function Monefp_showPopup() {
    const popup = document.getElementById("monefp-popup");
    popup.style.display = "block";
}
function Monefp_closePopup() {
    Monefp_setCookie("monefp-popup", "true", 365); // Cookie valid for 1 year
    const popup = document.getElementById("monefp-popup");
    popup.style.display = "none";
}

// ---- //
